// extracted by mini-css-extract-plugin
module.exports = {"micBtn":"micBtn___7mBXr","on":"on___3NcyB","icon":"icon___2y3BA","not-available":"not-available___2rSCL","warn":"warn___1_g8r"};